import { amountToDisplayValue } from '@billy/design-system'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { getImportedInvoiceDetailTotals } from '@features/importedInvoices/utils/getImportedInvoiceDetailTotals'

import { ImportedInvoiceApproved } from '../../../../../../types/importedInvoiceApproved'
import { ImportedInvoiceDetailAccordion } from '../ImportedInvoiceDetailAccordion'
import { ImportedInvoiceDetailRow, ImportedInvoiceDetailRows } from '../ImportedInvoiceDetailRows'

interface ImportedInvoiceDetailTotalProps {
  approved: ImportedInvoiceApproved
}

/** The invoice totals, closed by default and shown after the invoice lines. */
export const ImportedInvoiceDetailTotal = ({ approved }: ImportedInvoiceDetailTotalProps): ReactElement => {
  const { t } = useTranslation()

  const { totalAmountExclVat, totalAmountInclVat, totalVatAmount } = getImportedInvoiceDetailTotals(approved)
  const formattedTotalAmountInclVat = amountToDisplayValue(totalAmountInclVat, false, approved.currencyId)

  return (
    <ImportedInvoiceDetailAccordion
      subtitle={formattedTotalAmountInclVat}
      title={t('imported_invoices.detail.total_incl_vat')}
    >
      <ImportedInvoiceDetailRows>
        <ImportedInvoiceDetailRow
          label={t('imported_invoices.review.form.amount_excl_vat')}
          value={amountToDisplayValue(totalAmountExclVat, false, approved.currencyId)}
        />
        <ImportedInvoiceDetailRow
          label={t('imported_invoices.review.form.vat_amount')}
          value={amountToDisplayValue(totalVatAmount, false, approved.currencyId)}
        />
        <ImportedInvoiceDetailRow
          label={t('imported_invoices.review.form.amount_incl_vat')}
          value={formattedTotalAmountInclVat}
        />
      </ImportedInvoiceDetailRows>
    </ImportedInvoiceDetailAccordion>
  )
}
